import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import { BlockBorderProps } from "@store/Library/Components/Toolkit/Block";

export const defaultBorderProps: BlockBorderProps = {
    width: pxToRem(1),
    type: "solid",
    color: "common.border",
};
